$(function() {
    $('.goPedido').on('click', function () {

        if (!$("input:radio[name=addressSelect]").is(":checked")) {
            swal({
                title: "",
                text: "¡Debe escoger alguna dirección!",
                icon: imageURL,
            });
            return false;
        }

        if(!$("#terms").is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
        var id = 1;
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });
        $.ajax({
            url: https + "goPedido",
            method: "POST",
            data: {id: id, action: "goPedido"},
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payu";
                }else if($.trim(data) == "FOOD"){
                    swal({
                        title: "",
                        text: "Lo sentimos \n La compra total para alimentos diferentes de mantequilla de mani y mantequilla de almendras debe ser mayor a $70.000 COP",
                        icon: imageURL,
                        button: "OK!",
                    });
                }else {
                    swal({
                        text: "" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    });

    $('.notPedido').on('click', function () {
        swal({
            text: "No tiene productos para comprar",
            icon: imageURL,
            button: "OK!",
        });
    });

    function formPayu() {
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $('#formPayu').submit();
    }
});
